// extracted by mini-css-extract-plugin
export default {"compare-slider-divider":"style_compare-slider-divider__pjy9x"};